import React, { FC, SyntheticEvent } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { useMetadataTagDetails } from "../../context";
import { MetadataTagDetailsTabs } from "../../context/types";
import { StyledTab, StyledTabs } from "./styled";
import useRolePermission from "entities/auth/hooks/useRolePermission";

const Tabs: FC = () => {
  const { selectedTab, setSelectedTab } = useMetadataTagDetails();
  const { allowed: hasReadAccess } = useRolePermission("tags:read");
  const { allowed: hasReadTranslationsAccess } = useRolePermission("tags:translations:read");

  const shouldRenderGeneralTab = hasReadAccess;
  const shouldRenderTranslationsTab = hasReadAccess || hasReadTranslationsAccess;

  const handleTabChange = (_: SyntheticEvent, newTab: MetadataTagDetailsTabs) => {
    setSelectedTab(newTab);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      {shouldRenderGeneralTab && (
        <StyledTab
          id="metadata-tag-tab-general"
          aria-controls="metadata-tag-tabpanel-general"
          value={MetadataTagDetailsTabs.General}
          disableRipple
          label="General"
        />
      )}
      {shouldRenderTranslationsTab && (
        <StyledTab
          id="metadata-tag-tab-translations"
          aria-controls="metadata-tag-tabpanel-translations"
          value={MetadataTagDetailsTabs.Translations}
          disableRipple
          label="Translations"
        />
      )}
    </StyledTabs>
  );
};

export default Tabs;
